import App from './App';
import {MsalProvider} from "@azure/msal-react";
import {getMsalInstance} from "../api/msalInstance";


const msalInstance = getMsalInstance();


function Oauth() {
    return (
        <MsalProvider instance={msalInstance} forceLogin={true}>
            <App/>
        </MsalProvider>
    );
}

export default Oauth;